import { Dispatch, SetStateAction } from 'react';
import { toast } from 'react-toastify';
import fetchWithAuth from 'shared/services/fetchWithAuth';

type DownloadReportPromoFileType = {
  url: string;
  setIsLoadingDownloadTable: Dispatch<SetStateAction<boolean>>;
};

export const downloadReportPromoFile = ({ url, setIsLoadingDownloadTable }: DownloadReportPromoFileType) => {
  fetchWithAuth(url, { method: 'GET' })
    .then((response) => {
      if (!response.ok) {
        // Handle non-403 errors
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.blob();
    })
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Promo.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);

      setIsLoadingDownloadTable(false);
    })
    .catch(() => {
      setIsLoadingDownloadTable(false);
      toast.error('Произошла ошибка при скачивании файла', {
        position: toast.POSITION.TOP_RIGHT,
      });
    });
};
